import React, { useState, useEffect } from 'react';
import { theme } from '../config/theme';

const COUNTDOWN_SECONDS = 60;

const styles = {
    banner: {
        position: 'fixed',
        top: 'calc(env(safe-area-inset-top) + 1rem)',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 3000,
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        maxWidth: '92%',
        backgroundColor: theme.colors.primary,
        color: theme.colors.textPrimary,
        padding: '0.75rem 1.25rem',
        borderRadius: theme.borderRadius,
        boxShadow: theme.shadows.soft,
        fontFamily: theme.typography.fontFamily,
        fontSize: '0.9rem',
    },
    text: { margin: 0, display: 'flex', flexDirection: 'column', gap: '0.15rem' },
    title: { fontFamily: theme.typography.titleFamily, fontWeight: '600' },
    countdown: { fontSize: '0.8rem', color: theme.colors.textSecondaryOnDark },
    button: {
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.colors.surface,
        color: theme.colors.primary,
        border: 'none',
        borderRadius: theme.borderRadius,
        padding: '0.5rem 1rem',
        fontSize: '0.85rem',
        fontWeight: '700',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
};

/**
 * Aviso de versión nueva disponible. Muestra una cuenta regresiva y recarga
 * automáticamente al llegar a 0; el botón permite actualizar al instante.
 */
const UpdateBanner = ({ onReloadNow }) => {
    const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setSecondsLeft((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (secondsLeft <= 0) {
            onReloadNow();
        }
    }, [secondsLeft, onReloadNow]);

    return (
        <div style={styles.banner} role="alert">
            <p style={styles.text}>
                <span style={styles.title}>Hay una versión nueva de la planilla.</span>
                <span style={styles.countdown}>
                    Actualizando en {Math.max(secondsLeft, 0)}s…
                </span>
            </p>
            <button type="button" style={styles.button} onClick={onReloadNow}>
                Actualizar ahora
            </button>
        </div>
    );
};

export default UpdateBanner;
